import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class InternalTableService {
  baseUrl = 'internal-table';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  getColumns = (id) => BaseService.get({ url: `${this.baseUrl}/get-columns/${id}` });
  getPaginatedData = (id, paginationSettings) => BaseService.post({ url: `${this.baseUrl}/get-paginated-data/${id}`, data: paginationSettings });
  getLinkedTableData = (id) => BaseService.get({ url: `${this.baseUrl}/get-linked-table-data/${id}` });
  get = (id) => BaseService.get({ url: `${this.baseUrl}/get/${id}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  validateAffectedFields = (id) => BaseService.post({ url: `${this.baseUrl}/validate-affected-fields/${id}` });
  save = (internalTable) => BaseService.post({ url: `${this.baseUrl}/save`, data: internalTable });

  import = (file) => BaseService.postFormData({ url: `${this.baseUrl}/import`, data: file });

  saveDataRow = (id, rowData) => BaseService.post({ url: `${this.baseUrl}/save-data-row/${id}`, data: rowData });
  deleteDataRow = (id, row) => BaseService.get({ url: `${this.baseUrl}/delete-data-row/${id}/${row}` });
  addData = (defFieldId, internalTableData) => BaseService.post({ url: `${this.baseUrl}/add-data/${defFieldId}`, data: internalTableData });
}

export default new InternalTableService();
